import { BlogSection } from "@/types/blog";

export const entscheidungen: BlogSection = {
  id: "entscheidungen-in-unsicherheit",
  title: "Entscheidungen in Unsicherheit treffen",
  content: `
    <p>Nicht alles ist planbar. Informationen bleiben unvollständig.</p>

    <p>Führung bedeutet deshalb, Entscheidungen zu treffen und sie transparent zu machen. Menschen akzeptieren auch unvollkommene Lösungen, wenn sie fair und nachvollziehbar sind.</p>

    <p>Vertrauen entsteht durch Klarheit, nicht durch Perfektion.</p>
  `
};
